exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ivu-table .gray-row td{\n    background-color: #c5c5c5!important;\n}", ""]);

// exports
